module.exports = __webpack_public_path__ + "static/media/check.b5939cfd.png";